import parseDOM, {
  processStylesheet,
  processStyle,
  processScripts,
  processForm,
  processButton,
  processLink,
  processBlock,
} from 'components/storefront/editor/easyblocks-page/parser/dom';

import { INLINE_EDITABLE_ATTRIBUTE } from 'components/storefront/editor/easyblocks-page/parser/dom/instructions/block';

/** @typedef {import('@swell/apps-sdk').SwellTheme} SwellTheme */
/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {SwellTheme} theme
 * @param {object} blocksData
 * @param {object[]} blockElements
 * @param {object[]} inlineEditableConfigs
 * @param {AssetLoader} assetLoader
 */
function getInstructions(
  theme,
  blocksData,
  blockElements,
  inlineEditableConfigs,
  assetLoader,
) {
  return [
    processStylesheet(assetLoader),
    processStyle(assetLoader),
    processScripts(assetLoader),
    processForm(theme),
    processButton(theme),
    processBlock(blocksData, blockElements, inlineEditableConfigs),
    processLink(theme),
  ];
}

/**
 * @param {ChildNode} node
 * @returns {boolean}
 */
function isPortalContainer(node) {
  if (node.attributes) {
    return node.attributes.getNamedItem(INLINE_EDITABLE_ATTRIBUTE) !== null;
  }

  return false;
}

/**
 * @param {string} template
 * @param {SwellTheme} theme
 * @param {object} blocksData
 * @param {AssetLoader} assetLoader
 * @param {ChildNode[]} [prevElements]
 */
function parse(template, theme, blocksData, assetLoader, prevElements) {
  /** @type {object[]} */
  const blockElements = [];
  /** @type {object[]} */
  const inlineEditableConfigs = [];

  const elements = parseDOM(
    template,
    getInstructions(
      theme,
      blocksData,
      blockElements,
      inlineEditableConfigs,
      assetLoader,
    ),
    prevElements,
    isPortalContainer,
  );

  return { elements, blockElements, inlineEditableConfigs };
}

export default parse;
